import { render, staticRenderFns } from "./UserRoleDropdown.vue?vue&type=template&id=563074c2&scoped=true"
import script from "./UserRoleDropdown.vue?vue&type=script&lang=js"
export * from "./UserRoleDropdown.vue?vue&type=script&lang=js"
import style0 from "./UserRoleDropdown.vue?vue&type=style&index=0&id=563074c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563074c2",
  null
  
)

export default component.exports